<app-breadcrumb [home]="home" [items]="breadcrumbs()" />

@if (loading()) {
  <div class="client-detail__state">
    <app-cog-loading-spinner />
  </div>
} @else if (error()) {
  <div class="client-detail__state client-detail__state--error" role="alert">
    <i class="pi pi-video" aria-hidden="true"></i>
    <strong>{{ error() }}</strong>
    <a routerLink="/dashboard/client-meetings">Voltar para as calls</a>
  </div>
} @else if (meeting(); as m) {
  <header class="client-detail__header">
    <h2 class="client-detail__title">{{ title() }}</h2>
    @if (m.shortDescription) {
      <p class="client-detail__description">{{ m.shortDescription }}</p>
    }
    <p class="client-detail__meta">
      <i class="pi pi-calendar" aria-hidden="true"></i>
      {{ m.scheduledStartAt | vaultDateTime }}
      @if (m.durationSeconds != null) {
        · {{ duration(m.durationSeconds) }}
      }
    </p>
  </header>

  <div class="client-detail">
    <div class="client-detail__main">
      @if (videoUrl(); as url) {
        <video class="client-detail__video" [src]="url" controls preload="metadata"></video>
      } @else {
        <div class="client-detail__no-video">
          <i class="pi pi-video" aria-hidden="true"></i>
          <span>{{
            !m.hasRecording
              ? 'Esta call não tem gravação.'
              : videoUnavailable()
                ? 'A gravação desta call não está disponível no momento. Fale com a Legatus se precisar dela.'
                : 'Carregando o vídeo...'
          }}</span>
        </div>
      }

      @if (insights(); as i) {
        <section class="client-detail__card">
          <h3>Resumo</h3>
          @if (i.summary) {
            <p class="client-detail__summary">{{ i.summary }}</p>
          } @else {
            <p class="client-detail__muted">O resumo desta call ainda não está pronto.</p>
          }
          @if (i.decisions.length) {
            <h4>Decisões</h4>
            <ul>
              @for (d of i.decisions; track $index) {
                <li>{{ d.text }}</li>
              }
            </ul>
          }
          @if (i.nextSteps.length) {
            <h4>Próximos passos</h4>
            <ul>
              @for (s of i.nextSteps; track $index) {
                <li>
                  {{ s.text }}
                  @if (s.owner) {
                    <span class="client-detail__muted">· {{ s.owner }}</span>
                  }
                  @if (s.dueDate) {
                    <span class="client-detail__muted">· até {{ s.dueDate | vaultDate }}</span>
                  } @else if (s.dueText) {
                    <span class="client-detail__muted">· {{ s.dueText }}</span>
                  }
                </li>
              }
            </ul>
          }
          @if (i.pendingItems.length) {
            <h4>Pendências</h4>
            <ul>
              @for (p of i.pendingItems; track $index) {
                <li>{{ p.text }}</li>
              }
            </ul>
          }
          @if (i.chapters.length) {
            <h4>Capítulos</h4>
            <ul class="client-detail__chapters">
              @for (c of i.chapters; track $index) {
                <li>
                  <span class="client-detail__clock">{{ clock(c.startSeconds) }}</span>
                  {{ c.title }}
                </li>
              }
            </ul>
          }
        </section>
      }
    </div>

    <aside class="client-detail__side">
      <section class="client-detail__card">
        <h3>Participantes</h3>
        <ul class="client-detail__people">
          @for (p of m.participants; track $index) {
            <li>
              <strong>{{ p.name || 'Participante' }}</strong>
              @if (p.organization) {
                <span class="client-detail__muted">{{ p.organization }}</span>
              }
            </li>
          } @empty {
            <li class="client-detail__muted">Sem participantes registrados.</li>
          }
        </ul>
      </section>

      @if (m.links?.length) {
        <section class="client-detail__card">
          <h3>Vínculos</h3>
          <ul class="client-detail__people">
            @for (l of m.links; track $index) {
              <li>{{ l.name }}</li>
            }
          </ul>
        </section>
      }

      <section class="client-detail__card client-detail__transcript">
        <h3>Transcrição</h3>
        @for (s of segments(); track $index) {
          <p class="client-detail__segment">
            @if (clock(s.startSeconds); as at) {
              <span class="client-detail__clock">{{ at }}</span>
            }
            @if (s.speaker) {
              <strong>{{ s.speaker }}:</strong>
            }
            {{ s.text }}
          </p>
        } @empty {
          <p class="client-detail__muted">
            {{
              !m.hasTranscript
                ? 'Esta call não tem transcrição.'
                : transcriptDone()
                  ? 'A transcrição desta call não está disponível no momento.'
                  : 'Carregando a transcrição...'
            }}
          </p>
        }
      </section>
    </aside>
  </div>
}
